export const newOfficer = (officer, officerType) => {
  return {
    ...officer,
    officerType: { id: officerType, name: "" },
  };
};
